/* eslint-disable */

var vccsupport = {};
var vcc = {};

export class VCCSupportSite {
    vccsupport = {};
        
    constructor() {
        const self = this;

        this.initPrototypes();

        this.oMenutTimeout = 0;
        vcc = {
            isMobileViewport: false
        };

        this.initVccSupport();

        // global variables
        window.vcc = vcc;
    
        $(document).ready(function () {
            var win = $(window);

            // Horrendous
            if (self.vccsupport.ie6 || self.vccsupport.ie7 || self.vccsupport.ie8 || self.vccsupport.ie9) {
                $("html").addClass("oldie");
            }
    
            // self.vccsupport.ensureMarketCookie();
    
            //if (self.vccsupport.isDesktopMode()) {
            //    $("meta[name='viewport']").attr("content", "width=1024, minimum-scale=0.02");
            //
            //    $("#advisory .background").width(win.width());
            //    $("#ctl00_pnlTop > div").width($("#page").width());
            //    $("#sticky-menu").width($("#page").width());
            //    win.resize(function (e) {
            //        $("#advisory .background").width($(this).width());
            //        $("#ctl00_pnlTop > div").width($("#page").width());
            //        $("#sticky-menu").width($("#page").width());
            //    });
            //
            //    if (self.vccsupport.isAndroidTablet()) {
            //        $("#ctl00_pnlTop").width($(window).width());
            //    }
            //
            //    if ("-ms-user-select" in document.documentElement.style && self.vccsupport.isWindowsTablet()) {
            //        var msViewportStyle = document.createElement("style");
            //        msViewportStyle.appendChild(
            //            document.createTextNode("@media all and (orientation: portrait) { @-ms-viewport { width:1024px!important; } }")
            //        );
            //        msViewportStyle.appendChild(
            //            document.createTextNode("@media all and (orientation: landscape) { @-ms-viewport { width:auto!important; } }")
            //        );
            //        document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
            //    }
            //} else {
            //    vcc.isMobileViewport = true;
            //
            //    if ("-ms-user-select" in document.documentElement.style && navigator.userAgent.match(/IEMobile/)) {
            //        var msViewportStyle = document.createElement("style");
            //        msViewportStyle.appendChild(
            //            document.createTextNode("@media all and (orientation: portrait) { @-ms-viewport { width:auto!important; } }")
            //        );
            //        msViewportStyle.appendChild(
            //            document.createTextNode("@media all and (orientation: landscape) { @-ms-viewport { width:420px!important; } }")
            //        );
            //        document.getElementsByTagName("head")[0].appendChild(msViewportStyle);
            //    }
            //
            //    this.vccsupport.setViewportForMobile();
            //}
    
            // self.vccsupport.initNav();
            // self.vccsupport.initFooter();
            // self.vccsupport.searchBoxBehaviour();
    
            if (self.vccsupport.ie6) {
                $(document.body).addClass("ie6");
                self.vccsupport.ie67fixer();
            }
            else if (self.vccsupport.ie7) {
                $(document.body).addClass("ie7");
                self.vccsupport.ie67fixer();
            }
            else if (self.vccsupport.ie8) {
                $(document.body).addClass("ie8");
            }
    
            // create overlays
            var pos = "fixed";
            if (self.vccsupport.ie6) {
                pos = "absolute";
            }

            self.vccsupport.Overlay = function(options) {
    
                var defaults = {
                    overlayid: "overlay",
                    overlaymarkup: "<div id='{0}'></div>",
                    containerid: "",
                    containermarkup: "<div id='{0}'></div>",
                    closebuttonmarkup: "<a href='#' class='close-overlay'></a>",
                    center: true,
                    containerCss: {
                        display: "none",
                        position: "fixed",
                        backgroundColor: "transparent"
                    },
                    fadeIn: {},
                    fadeOut: {},
                    // container offset (overrides "center" setting)
                    offset: {
                        left: undefined,
                        right: undefined,
                        top: undefined,
                        bottom: undefined
                    },
                    overlayCss: {
                        backgroundColor: "#000",
                        display: "none",
                        opacity: 0.75,
                        position: "fixed",
                        top: 0
                    },
                    resize: true,
                    scroll: false
                },
                    jqDataKeyOverflow = "originalOverflow",
                    parent = $("body"),
                    form = parent.find("form"),
                    _window = $(window),
                    events = {
                        hide: "hide"
                    };
        
                function Overlay(options) {
                    var _options,
                        overlay,
                        container,
                        onHideCallback,
                        initialized = false,
                        pub = $({});
        
                    if (this instanceof Overlay) {
                        alert("Don't use new. :)");
                    }
        
                    _options = $.extend(true, { overlayCss: { height: _window.height(), width: _window.width() } }, defaults, options);
        
                    function init() {
                        if (initialized) return;
        
                        if (_options.scroll) {
                            if (_options.overlayCss.position !== "absolute") {
                                _options.overlayCss.position = "absolute";
                            }
                        }
        
                        // setup overlay element
                        overlay = $(_options.overlayid);
                        if (overlay.length === 0) {
                            overlay = $(_options.overlaymarkup.format(_options.overlayid))
                                .css(_options.overlayCss)
                                .appendTo(parent)
                                // setup onclick close event
                                .on("click", function (e) {
                                    onhide();
                                });
                        }
                        // setup container element
                        if (_options.containerid.length > 0) {
                            container = $(_options.containerid);
                            if (container.length === 0) {
                                container = $(_options.containermarkup.format(_options.containerid))
                                    .css(_options.containerCss)
                                    .appendTo(parent);
                            }
                        }
        
                        initialized = true;
                    };
        
                    // private functions
                    function center() {
                        if (!container) return;
        
                        var h = _window.height(), w = _window.width(),
                            h2 = container.outerHeight(), w2 = container.outerWidth(),
                            l, r, t, b, o = {}, st = 0, sl = 0;
        
                        if (_options.offset) {
                            // left
                            l = _options.offset.left;
                            if (typeof l === "string") {
                                l = parseInt(l.trim("%"), 10);
                                if (t === NaN) {
                                    l = 0;
                                }
                                else {
                                    l = w * (l / 100);
                                }
                            }
                            // right
                            r = _options.offset.right;
                            if (typeof r === "string") {
                                r = parseInt(r.trim("%"), 10);
                                if (r === NaN) {
                                    r = 0;
                                }
                                else {
                                    r = h * (r / 100);
                                }
                            }
                            // top
                            t = _options.offset.top;
                            if (typeof t === "string") {
                                t = parseInt(t.trim("%"), 10);
                                if (t === NaN) {
                                    t = 0;
                                }
                                else {
                                    t = h * (t / 100);
                                }
                            }
                            // bottom
                            b = _options.offset.bottom;
                            if (typeof b === "string") {
                                b = parseInt(b.trim("%"), 10);
                                if (b === NaN) {
                                    b = 0;
                                }
                                else {
                                    b = h * (b / 100);
                                }
                            }
                        }
        
                        if (_options.containerCss.position === "absolute") {
                            sl = _window.scrollLeft();
                            st = _window.scrollTop();
                        }
        
                        if (l) {
                            o.left = l + sl;
                        }
                        else if (r) {
                            o.right = r + sl;
                        }
                        else {
                            o.left = ((w - w2) / 2) + sl;
                        }
        
                        if (t) {
                            o.top = t + st;
                        }
                        else if (b) {
                            o.bottom = b + st;
                        }
                        else {
                            o.top = ((h - h2) / 2) + st;
                        }
        
                        container.css(o);
                    };
        
                    function getSize() {
                        var o = {}, h, w;
        
                        if (_options.scroll) {
                            h = parent.outerHeight();
                            w = parent.outerWidth();
                        }
                        else {
                            h = form.outerHeight();
                            w = form.children().eq(0).outerWidth(); // do not include scrollbar
                            //h = _window.height();
                            //w = _window.width();
                        }
        
                        return { height: h, width: w };
                    };
        
                    function hide(callback) {
                        if (typeof callback === "undefined") {
                            onhide();
                        }
                        else if (typeof callback === "function") {
                            pub.on(events.hide, callback);
                        }
                    };
                    function onhide() {
                        var c, opt;
                        if (_options.resize) {
                            _window.off("resize", resize);
                        }
        
                        if (typeof onHideCallback === "function") {
                            onHideCallback();
                            onHideCallback = undefined;
                        }
                        else {
                            pub.trigger(events.hide);
                        }
        
                        if (typeof _options.fadeOut === "object") {
                            opt = $.extend({}, _options.fadeOut);
                            opt.complete = function () {
                                if (typeof _options.fadeOut.complete === "function") {
                                    _options.fadeOut.complete.call(parent);
                                }
                                if (container)
                                    container.empty();
                            };
                            overlay.add(container).fadeOut(opt);
                        }
                        else {
                            overlay.add(container).hide();
                            container.empty();
                        }

                        $('body').removeClass('show-image-overlay');
        
                        if (_options.scroll === false) {
                            // Revert overflow for PARENT
                            o = $.data(parent[0], jqDataKeyOverflow);
                            parent.css(o);
                            // Revert overflow for FORM
                            o = $.data(form[0], jqDataKeyOverflow);
                            form.css(o);
                        }
                    };
        
                    function resize(e) {
                        var o = getSize();
                        overlay.css(o);
                        if (_options.center) {
                            center();
                        }
                    };
        
                    function show(content, onHide) {
                        var btn, opt;
        
                        init();
        
                        if (typeof onHide === "function") {
                            onHideCallback = onHide;
                        }
        
                        if (_options.resize) {
                            resize();
                            _window.on("resize", resize);
                        }
        
                        // if (_options.scroll === false) {
                        //     // store and update overflow for FORM
                        //     o = $.data(form[0], jqDataKeyOverflow);
                        //     if (!o) {
                        //         o = {
                        //             overflow: form.css("overflow"),
                        //             overflowX: form.css("overflowX"),
                        //             overflowY: form.css("overflowY")
                        //         };
                        //         $.data(form[0], jqDataKeyOverflow, o);
                        //     }
                        //     form.css({
                        //         overflow: "auto",
                        //         overflowX: "auto",
                        //         overflowY: "scroll"
                        //     });
                        //     // store and update overflow for PARENT
                        //     o = $.data(parent[0], jqDataKeyOverflow);
                        //     if (!o) {
                        //         o = {
                        //             overflow: parent.css("overflow"),
                        //             overflowX: parent.css("overflowX"),
                        //             overflowY: parent.css("overflowY")
                        //         };
                        //         $.data(parent[0], jqDataKeyOverflow, o);
                        //     }
                        //     parent.css({
                        //         overflow: "hidden",
                        //         overflowX: "hidden",
                        //         overflowY: "hidden"
                        //     });
                        // }
                        // else {
                        //     // Revert form
                        //     o = $.data(form[0], jqDataKeyOverflow);
                        //     if (o) {
                        //         form.css(o);
                        //     }
                        //     // Revert parent
                        //     o = $.data(parent[0], jqDataKeyOverflow);
                        //     if (o) {
                        //         parent.css(o);
                        //     }
                        // }
        
                        if (container) {
                            container.append(content);
                            if (_options.closebuttonmarkup && _options.closebuttonmarkup.length) {
                                btn = $(_options.closebuttonmarkup)
                                    .click(function (e) {
                                        e.preventDefault();
                                        onhide();
                                    })
                                    .appendTo(container);
                            }
                        }
        
                        if (_options.fadeIn) {
                            if (typeof _options.fadeIn === "object") {
                                opt = $.extend({}, _options.fadeIn);
                            }
                            else {
                                opt = _options.fadeIn;
                            }
        
                            overlay.add(container).fadeIn(opt);
                            center();
                        }
                        else {
                            overlay.add(container).show();
                            if (_options.center) {
                                center();
                            }
        
                        }
                    };
        
                    // public functions
                    return {
                        containerCss: function (css) {
                            init();
                            container.css(css);
                        },
                        overlayCss: function (css) {
                            init();
                            overlay.css(css);
                        },
                        hide: function (callback) {
                            hide(callback);
                        },
                        show: function (content, onHide) {
                            $('body').addClass('show-image-overlay');
                            show(content, onHide);
                        },
                        setScroll: function (scroll) {
                            if (scroll) {
                                _options.scroll = true;
                            }
                            else {
                                _options.scroll = false;
                            }
                        }
                    }
                };
        
                return Overlay(options);
        
            };
            // self.vccsupport.videoOverlay = self.vccsupport.Overlay({
            //     containerid: "video-overlay-container",
            //     overlayid: "video-overlay",
            //     containerCss: { height: 380, position: pos, width: 675, zIndex: 1001 },
            //     overlayCss: { position: pos, zIndex: 1000 },
            //     fadeOut: undefined,
            //     offset: {
            //         top: "15%"
            //     }
            // });
            self.vccsupport.scrollableOverlay = self.vccsupport.Overlay({
                overlayid: "scrollable-overlay",
                overlayCss: {
                    position: "absolute",
                    zIndex: 1000
                },
                containerid: "scrollable-overlay-container",
                containerCss: {
                    position: "absolute",
                    zIndex: 1001
                },
                fadeOut: undefined,
                scroll: true
            });
            // self.vccsupport.navOverlay = self.vccsupport.Overlay({
            //     overlayid: "nav-overlay",
            //     overlayCss: {
            //         position: pos,
            //         zIndex: 998,
            //         top: 140
            //     },
            //     fadeOut: undefined
            // });
    
            // self.vccsupport.alertOverlay = self.vccsupport.Overlay({
            //     overlayid: "mobile-overlay",
            //     containerid: "mobile-overlay-container",
            //     overlayCss: { position: "fixed", zIndex: 1000 },
            //     containerCss: { backgroundColor: "#fff", position: "fixed", zIndex: 1001, width: self.vccsupport.isDesktopMode() ? "675px" : "90%" },
            //     scroll: false
            // });
        });
        
        $(window).on("load", function () {
            self.vccsupport.touchDoubleClickFix();
    
            if (!self.vccsupport.ie6 && (self.vccsupport.market && self.vccsupport.market.length)) {
                $("#search-box input:first").suggestions({
                    click: function () {
                        $("#search-box .search-box-button").click();
                    },
                    serviceUrl: "/{0}/_vti_bin/SearchService.svc/Suggestions".format(self.vccsupport.market)
                });
            }
        });
    
        //$(window).resize(function () {
            //vcc.isMobileViewport = !self.vccsupport.isDesktopMode();
    
            /*self.vccsupport.initNav();
            self.vccsupport.initFooter();
            self.vccsupport.searchBoxBehaviour();*/
        //});
    }
    initPrototypes() {
        const self = this;

        String.prototype.format = function () {
            var args = arguments;
            return this.replace(/{(\d+)}/g, function (match, number) {
                return typeof args[number] !== 'undefined' ? args[number] : match;
            });
        };
        
        String.prototype.tmpl = function (obj) {
            return this.replace(/{(\w+)}/g, function (match, value) {
                var p;
                for (p in obj) {
                    if (p.toLowerCase() === value.toLowerCase()) {
                        return obj[p];
                    }
                }
                return "";
            });
        };
        
        String.prototype.trim = function () {
            return this.trimStart().trimEnd();
        };
        
        String.prototype.trimStart = function () {
            var c = this;
            var s = this, values = [];
            
            function exists(value, values) {
                var i;
                for (i = 0; i < values.length; i++) {
                    if (values[i] === value) return true;
                }
                return false;
            };
        
            if (self.vccsupport.is(self.vccsupport.jstypes.array, c)) {
                for (p in c) {
                    if (c[p]) {
                        values.push(c[p].toString());
                    }
                }
            }
            else if (c) {
                values.push(c.toString());
            }
        
            if (values.length === 0) {
                values.push(" ");
            }
        
            while (exists(s.substring(0, 1), values)) {
                s = s.substring(1);
            }
            return s;
        };
        
        String.prototype.trimEnd = function (c) {
            var s = this, last, values = [];
        
            function exists(value, values) {
                var i;
                for (i = 0; i < values.length; i++) {
                    if (values[i] === value) return true;
                }
                return false;
            };
        
            if (self.vccsupport.is(self.vccsupport.jstypes.array, c)) {
                for (p in c) {
                    if (c[p]) {
                        values.push(c[p].toString());
                    }
                }
            }
            else if (c) {
                values.push(c.toString());
            }
        
            if (values.length === 0) {
                values.push(" ");
            }
        
            last = s.length - 1;
            while (exists(s.substring(last), values)) {
                s = s.substring(0, last);
                last = s.length - 1;
            }
            return s;
        };
    }
    
        // var oMenuTimeout = 0;
    
        // var vcc = {
        //     isMobileViewport: false
        // };
    
    initVccSupport() {
        this.vccsupport = {
            ARTICLE: "article",
            CAR_COOKIE_NAME: "CarSelector",
            CATEGORY: "category",
            MODEL_CODE: "mc",
            MODEL_NAME: "mn",
            MODEL_YEAR: "my",
            STRUCTURE_WEEK: "sw",
            STRUCTURE_WEEK_NAME: "swn",
            centerLightBoxVertically: false,
            originalSitename: "",
            ie6: (navigator && navigator.appVersion.indexOf("MSIE 6.") !== -1),
            ie7: (navigator && navigator.appVersion.indexOf("MSIE 7.") !== -1),
            ie8: (navigator && navigator.appVersion.indexOf("MSIE 8.") !== -1),
            ie9: (navigator && navigator.appVersion.indexOf("MSIE 9.") !== -1),
            ie10: (navigator && navigator.appVersion.indexOf("MSIE 10.") !== -1),
            ie11: function () {
                var rv = -1;
                if (navigator && navigator.appName == 'Netscape') {
                    var ua = navigator.userAgent;
                    var re = new RegExp("Trident/.*rv:([0-9]{1,}[\.0-9]{0,})");
                    if (re.exec(ua) != null)
                        rv = parseFloat(RegExp.$1);
                }
                return rv == 11;
            },
            init: function (data) {
                var self = this;
                this.resources.get = function (name) {
                    return data[name];
                };
                this.config.get = function (name) {
                    var cfg, pc = self.resources.get("PageConfig");
                    if (pc) {
                        cfg = pc[name];
                    }
                    return cfg;
                };
                // init common values
                this.isRTL = this.resources.get("isRTL");
                this.market = this.resources.get("market");
                this.version = this.resources.get("version");
                this.pagelayout = this.resources.get("pagelayout");
            },
            isAndroidTablet: function () {
                var ua = navigator.userAgent.toLowerCase();
                return (ua.search("android") > -1 && !(ua.search("mobile") > -1));
            },
            isWindowsTablet: function () {
                var ua = navigator.userAgent.toLowerCase();
                return (ua.search("touch") > -1 && (ua.search("windows nt") > -1) && (ua.search("arm") > -1));
            },
            jstypes: {
                array: Object.prototype.toString.call([]).slice(8, -1),
                boolean: Object.prototype.toString.call(true).slice(8, -1),
                date: Object.prototype.toString.call(new Date()).slice(8, -1),
                func: Object.prototype.toString.call(function () { }).slice(8, -1),
                number: Object.prototype.toString.call(0).slice(8, -1),
                object: Object.prototype.toString.call({}).slice(8, -1),
                regexp: Object.prototype.toString.call(/ /).slice(8, -1),
                string: Object.prototype.toString.call("").slice(8, -1)
            },
            is: function (type, obj) {
                var actualType = Object.prototype.toString.call(obj).slice(8, -1);
                return type.toLowerCase() === actualType.toLowerCase();
            },
            isDesktopMode: function () {
                return $(window).width() > 768
            },
            config: { get: function (name) { } },
            resources: { get: function (name) { } },
            setViewportForMobile: function () {
                var topnav = $("#page-top-wrapper");
                var search = $("#search-area");
                var mql = window.matchMedia("(orientation: landscape)");
                if (mql.matches) {
                    $("meta[name='viewport']").attr("content", "width=420, user-scalable=0");
                    topnav.addClass("not-sticky");
                    search.addClass("not-sticky");
                }
    
                mql.addListener(function (m) {
                    if (m.matches) {
                        if (window.orientation !== 0) {
                            $("meta[name='viewport']").attr("content", "width=420, user-scalable=0");
                            if (topnav.hasClass("menu-open"))
                                $("html, body").animate({ scrollTop: 0 }, 0);
                        }
                    }
                    else {
                        $("meta[name='viewport']").attr("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0");
                    }
    
                    topnav.toggleClass("not-sticky");
                    search.toggleClass("not-sticky");
    
                    if (topnav.hasClass("menu-open")) {
                        $("#page").width($("body").width());
                        self.resizeOverlay();
                    }
                });
            },
            // isLandscape: function () {
            //     return window.matchMedia("(orientation: landscape)").matches;
            // },
            // initNav: function () {
            //     $("#nav li a").addClass("handleTouch");
            //     $("#menu-topics a").addClass("handleTouch");
            //     $("#menu-downloads a").addClass("handleTouch");
    
            //     if (this.isDesktopMode()) {
            //         this.initNavForDesktop();
            //         this.fixedNav.on();
            //         var menuLinks = $("a.menu-link");
            //         menuLinks.off("click").on("click", function (e) {
            //             e.preventDefault();
            //             this.toggleMenu(this);
            //             return false;
            //         });
            //     } else {
            //         this.initNavForMobile();
            //     }
            // },
            // initNavForDesktop: function () {
            //     var self = this;
            //     var oNav = $("#nav");
            //     oNav.find("li:first").addClass("first");
    
            //     var sSitename = $(".site-name");
            //     if (sSitename.length > 0) {
            //         if (this.originalSitename.length == 0)
            //             this.originalSitename = sSitename.html();
    
            //         sSitename.html(sSitename.html().replace("<br />", " ").replace("<br>", " ").replace("<BR>", " "));
            //     }
    
            //     if ((this.ie6 && this.isRTL) || (this.ie7 && this.isRTL)) {
            //         var width = 0, logo = $("#logo"), nav = $("#nav");
            //         logo.width(logo.find("a").outerWidth(true) + logo.find(".site-name").outerWidth(true));
            //         nav.find("li").each(function () {
            //             width += $(this).outerWidth(true);
            //         });
            //         nav.width(width);
            //     }
    
            //     if (this.ie6 || this.ie7) {
            //         var contactModule = $("#ctl00_pnlContactModule");
            //         var innerDiv = contactModule.find(".contact-module-inner");
    
            //         if (innerDiv.find(".module").length < 3) {
            //             if (this.ie7) {
            //                 var _width = 0;
            //                 contactModule.find(".module").each(function () {
            //                     _width += $(this).width();
            //                 });
            //                 innerDiv.css("margin-left", (contactModule.width() - _width) / 2 + "px");
            //             }
            //             else {
            //                 innerDiv.css("margin-left", (contactModule.width() - innerDiv.width()) / 2 + "px");
            //             }
            //         }
    
            //         innerDiv.find(".module-inner").each(function () {
            //             var $this = $(this),
            //                 moduleLink = $this.find(".module-link a");
    
            //             var margin = (312 - $this.find(".icon").width() - moduleLink.width()) / 2;
            //             if (self.isRTL)
            //                 $this.css('margin-right', margin + 'px');
            //             else
            //                 $this.css('margin-left', margin + 'px');
    
            //             moduleLink.css('margin-top', (90 - moduleLink.height()) / 2 + 'px');
            //         });
            //     }
    
            //     if (this.ie6) {
            //         $("#search-button-image").hover(function () {
            //             $(this).addClass("hover");
            //         }, function () {
            //             $(this).removeClass("hover");
            //         });
            //     }
            // },
            // fixedNav: (function () {
    
            //     var init,
            //         hasTransparentTop,
            //         page,
            //         topWrapper,
            //         win,
            //         cut;
    
            //     function _init() {
            //         if (init) return;
            //         hasTransparentTop = .resources.get("hasTransparentTop");
            //         page = $("#page");
            //         topWrapper = $("#page-top-wrapper");
            //         win = $(window);
            //         cut = $("#ctl00_pnlSiteHeader").height();
            //         init = true;
            //     };
    
            //     function onScroll(e) {
            //         if (win.scrollTop() > cut) {
            //             page.addClass("fixed-nav");
            //             if (hasTransparentTop === true) {
            //                 topWrapper.removeClass("transparent");
            //             }
            //         }
            //         else {
            //             page.removeClass("fixed-nav");
            //             if (hasTransparentTop === true) {
            //                 topWrapper.addClass("transparent");
            //             }
            //         }
            //     };
    
            //     function on() {
            //         _init();
            //         if (win.scrollTop() > cut) {
            //             page.addClass("fixed-nav");
            //         }
            //         else if (hasTransparentTop === true) {
            //             topWrapper.addClass("transparent");
            //         }
    
            //         win.off("scroll", onScroll).on("scroll", onScroll);
            //     };
    
            //     function off() {
            //         _init();
            //         win.off("scroll", onScroll);
            //         page.removeClass("fixed-nav");
            //         if (hasTransparentTop === true) {
            //             topWrapper.addClass("transparent");
            //         }
            //     };
    
            //     return {
            //         on: on,
            //         off: off
            //     };
    
            // })(),
            // scrollPos: 0,
            // initNavForMobile: function () {
            //     var oTop = $("#page-top-wrapper"),
            //         oNavMenu = $("#ctl00_pnlNav"),
            //         oNavSearch = $("#search-area"),
            //         oMenuImg = $("#menu-button-image"),
            //         bSearchBox = this.resources.get("showSearchBox");
    
            //     if (bSearchBox)
            //         oNavSearch.slideDown('fast');
    
            //     if (vccsupport.originalSitename.length > 0)
            //         $(".site-name").html(vccsupport.originalSitename);
    
            //     var menuButton = $("#menu-button-mobile");
            //     menuButton.off("click").on("click", function () {
            //         if (oNavMenu.is(":visible")) {
            //             vccsupport.hideSimpleOverlay();
            //             vccsupport.togglePagePosition(false);
            //             oNavMenu.slideUp('fast');
            //             oNavMenu.parent().removeClass('open');
            //             oMenuImg.css("background-image", "url('/_layouts/15/VolvoCars.Sharepoint.Features.SupportSite/images/buttons/retina/menu_stop.gif')");
            //             vccsupport.closeMenu();
            //             oTop.removeClass("menu-open");
            //         }
            //         else {
            //             if (!bSearchBox) {
            //                 oNavSearch.slideUp('fast');
            //                 $("#search-button-mobile").removeClass("active");
            //             }
    
            //             if (oTop.hasClass("search-open")) {
            //                 oTop.addClass("menu-open").removeClass("search-open");
            //             }
            //             else {
            //                 vccsupport.togglePagePosition(true);
            //                 oTop.addClass("menu-open");
            //             }
    
            //             oNavMenu.slideDown('fast');
            //             oNavMenu.parent().addClass('open');
            //             oMenuImg.css("background-image", "url('/_layouts/15/VolvoCars.Sharepoint.Features.SupportSite/images/buttons/retina/menu_start.gif')");
            //             vccsupport.showSimpleOverlay();
            //         }
            //     });
    
            //     oNavMenu.find("> ul li:last").addClass("last");
    
            //     $("a.menu-link").each(function () {
            //         var that = $(this);
            //         that.parent().append($("#menu-" + this.id));
            //         that.off("click").on("click", function (e) {
            //             e.preventDefault();
            //             vccsupport.toggleMenu(this);
            //         });
            //     });
    
            //     if (!bSearchBox) {
            //         var oSearchButton = $("#search-button-mobile");
            //         oSearchButton.show();
            //         oSearchButton.off("click").on("click", function () {
            //             var $this = $(this);
            //             if ($this.hasClass("active")) {
            //                 oNavSearch.slideUp('fast');
            //                 oNavSearch.removeClass("menu-open");
            //                 oNavMenu.parent().removeClass('open');
            //                 oTop.removeClass("menu-open").removeClass("search-open");
            //                 $this.removeClass("active");
            //                 vccsupport.hideSimpleOverlay();
            //                 vccsupport.togglePagePosition(false);
            //             }
            //             else {
            //                 if (oNavMenu.is(":visible")) {
            //                     oNavMenu.slideUp('fast');
            //                     oMenuImg.css("background-image", "url('/_layouts/15/VolvoCars.Sharepoint.Features.SupportSite/images/buttons/retina/menu_stop.gif')");
            //                 }
            //                 $("#search-controls").show();
            //                 oNavSearch.slideDown('fast');
            //                 oNavSearch.addClass("menu-open");
            //                 oNavMenu.parent().removeClass('open');
            //                 $this.addClass("active");
            //                 vccsupport.showSimpleOverlay();
            //                 $("#search-box input[type=text]:first").focus();
    
            //                 if (oTop.hasClass("menu-open")) {
            //                     oTop.addClass("search-open");
            //                 }
            //                 else {
            //                     oTop.addClass("menu-open").addClass("search-open");
            //                     vccsupport.togglePagePosition(true);
            //                 }
            //             }
            //         });
            //     }
            // },
            // togglePagePosition: function (bIsAbsolute) {
            //     if (bIsAbsolute) {
            //         if (vccsupport.scrollPos == 0)
            //             vccsupport.scrollPos = $(window).scrollTop();
    
            //         $("#page").css({
            //             "position": "absolute",
            //             "width": $("body").width(),
            //             "top": vccsupport.scrollPos * -1
            //         });
    
            //         document.body.classList.add("no-scroll");
            //     }
            //     else {
            //         document.body.classList.remove("no-scroll");
            //         $("#page").css({
            //             "position": "relative",
            //             "width": "auto",
            //             "top": "auto"
            //         });
            //         $("html, body").animate({ scrollTop: vccsupport.isLandscape() ? 0 : vccsupport.scrollPos }, 0);
            //         vccsupport.scrollPos = 0;
            //     }
    
            // },
            // ensureMenuFits: function () {
            //     var height = $("#site-header").height() + $("#page-top").height() + $("#menu-wrapper").height();
            //     if (height > $(window).height()) {
            //         if (!vccsupport.ie6 && !vccsupport.ie7) {
            //             vccsupport.navOverlay.overlayCss({ position: "absolute" });
            //         }
            //         vccsupport.navOverlay.setScroll(true);
            //         vccsupport.fixedNav.off();
            //     }
            //     else {
            //         if (!vccsupport.ie6 && !vccsupport.ie7) {
            //             vccsupport.navOverlay.overlayCss({ position: "fixed" });
            //         }
            //         vccsupport.navOverlay.setScroll(false);
            //         vccsupport.fixedNav.on();
            //     }
            // },
            // toggleMenu: function (oLink) {
            //     var bSearchBox = this.resources.get("showSearchBox");
            //     vccsupport.closeMenu();
    
            //     if ($(".large-search-box").length == 0 && !bSearchBox) {
            //         $("#search-controls").slideUp('fast');
            //         $("#search-area").removeClass("menu-open");
            //     }
    
            //     var topnav = $("#ctl00_pnlTop");
            //     var oMenu = $("#menu-" + oLink.id);
            //     if (oMenu.is(":hidden")) {
            //         topnav.addClass("menu-open");
            //         oMenu.slideDown('fast', function () {
            //             if (vccsupport.isDesktopMode()) {
            //                 vccsupport.setMenuHeight(oMenu);
            //                 vccsupport.addToggleMenuListener(oMenu.attr("id"));
            //                 vccsupport.ensureMenuFits();
            //                 vccsupport.navOverlay.show();
    
            //                 if (vccsupport.ie6) {
            //                     vccsupport.navOverlay.overlayCss({ top: $("#ctl00_pnlMenu").offset().top + $("#ctl00_pnlMenu").height() });
            //                 }
            //                 else if (vccsupport.ie7) {
            //                     vccsupport.navOverlay.overlayCss({ top: (topnav.parent().hasClass("fixed-nav") ? 50 : 130) + $("#ctl00_pnlMenu").height() });
            //                 }
            //                 else {
            //                     vccsupport.navOverlay.overlayCss({ top: topnav.parent().hasClass("fixed-nav") ? 50 : 130 });
            //                 }
            //             }
            //         });
            //         $(oLink).addClass("expanded").parent().addClass("menu-active");
            //     } else {
            //         oMenu.slideUp('fast');
            //         $(oLink).removeClass("expanded").parent().removeClass("menu-active");
    
            //         if (vccsupport.isDesktopMode()) {
            //             vccsupport.navOverlay.hide();
            //             vccsupport.fixedNav.on();
            //         }
            //     }
            // },
            // closeMenu: function (bOnlyMenu) {
            //     if (vccsupport.isDesktopMode()) {
            //         if (!bOnlyMenu) {
            //             $("#ctl00_pnlTop").removeClass("menu-open");
            //         }
            //         var menu = $("#ctl00_pnlMenu .menu");
            //         if (!menu.is(":visible"))
            //             return;
            //         menu.slideUp('fast');
            //     }
            //     else
            //         $("#ctl00_pnlNav .menu").slideUp('fast');
    
            //     $("li.no-link").removeClass("menu-active");
            //     $("a.expandable").removeClass("expanded");
    
            // },
            // setMenuHeight: function (oMenu) {
            //     if (oMenu.height() === 0) {
            //         var iHeight = 0;
            //         if (oMenu.find("> div").length > 0) {
            //             oMenu.find("> div").each(function () {
            //                 if ($(this).height() > iHeight)
            //                     iHeight = $(this).height();
            //             });
    
            //             oMenu.height(iHeight + 26);
            //         }
            //         else {
            //             oMenu.find("ul.menu-column").each(function () {
            //                 if ($(this).height() > iHeight)
            //                     iHeight = $(this).height();
            //             });
    
            //             oMenu.height(iHeight + 74);
            //         }
            //     }
            // },
            // addToggleMenuListener: function (sMenuId) {
            //     $("body").on("click", function (e) {
            //         //console.log($(e.target).hasClass("search-button-image") + " " + e.target)
            //         if (e.target.id == sMenuId || $(e.target).parents("#" + sMenuId).length ||
            //             e.target.id == "search-box" || $(e.target).parents("#search-box").length ||
            //             ($(e.target).is("a") && $(e.target).hasClass("menu-link") && $(e.target).hasClass("menu-link")) ||
            //             ($(e.target).is("a") && !$(e.target).hasClass("search-button-image") && $(e.target).attr("href") != "" /*&& $(e.target).attr("href").indexOf("javascript:") == -1*/) ||
            //             ($(e.target).parents("a").length && $(e.target).parents("a").prop("href") != "" && $(e.target).parents("a").indexOf("javascript:") == -1)) {
            //             // Do not close menu
            //         } else {
            //             if ($(e.target).hasClass("search-button-image")) {
            //                 vccsupport.closeMenu(true);
            //             }
            //             else {
            //                 vccsupport.closeMenu();
            //                 vccsupport.navOverlay.hide();
    
            //                 if ($(".large-search-box").length == 0) {
            //                     var searchControls = $("#search-controls");
            //                     if (!searchControls.hasClass("always-visible")) {
            //                         searchControls.slideUp('fast');
            //                         $("#search-area").removeClass("menu-open");
            //                     }
            //                 }
    
            //                 $("body").off("click");
            //             }
            //         }
            //     });
            // },
            // initFooter: function () {
            //     if (vccsupport.isDesktopMode() && vccsupport.ie6) {
            //         $(".module-inner").each(function () {
            //             $(this).wrapInner("<center></center>");
            //         });
            //     }
            // },
            // toggleSearch: function (noAnimation, noFocus) {
            //     var searchArea = $("#search-area");
            //     var searchControls = $("#search-controls");
            //     var searchIsVisible = searchControls.is(":visible");
            //     var topnav = $("#ctl00_pnlTop");
    
            //     if ($(".small-search-box").length > 0) {
            //         searchControls.toggle("blind", noAnimation ? 1 : 300);
            //         $("#search-button-image").toggleClass("close-search");
            //         searchArea.toggleClass("menu-open");
    
            //         if (searchIsVisible) {
            //             vccsupport.navOverlay.hide();
            //             topnav.removeClass("menu-open");
            //         }
            //         else {
            //             topnav.addClass("menu-open");
            //             searchArea.width($("#page").width());
            //             vccsupport.navOverlay.show();
    
            //             if (vccsupport.ie6)
            //                 vccsupport.navOverlay.overlayCss({ top: 313 });
            //             else if (vccsupport.ie7)
            //                 vccsupport.navOverlay.overlayCss({ top: (topnav.parent().hasClass("fixed-nav") ? 50 : 130) + 173 });
            //             else
            //                 vccsupport.navOverlay.overlayCss({ top: topnav.parent().hasClass("fixed-nav") ? 50 : 130 });
    
            //             vccsupport.addToggleMenuListener();
            //         }
            //     }
    
            //     var hasLargeSearchBox = $(".large-search-box").length > 0;
            //     if (!noFocus && (!searchIsVisible || hasLargeSearchBox)) {
            //         if (hasLargeSearchBox) {
            //             $("body").click();
    
            //             var searchboxPos = $("#search-box").position().top;
            //             var winPos = $(window).scrollTop() + 70;
            //             if (winPos > searchboxPos) {
            //                 $("html, body").animate({ scrollTop: 0 }, 800, function () { $("#search-box input").get(0).focus(); });
            //             }
            //             else {
            //                 $("#search-box input").get(0).focus();
            //             }
            //         }
            //         else {
            //             $("#search-box input").get(0).focus();
            //         }
            //     }
            // },
            // hideSearch: function (noAnimation, noFocus) {
            //     var searchIsVisible = $("#search-controls").is(":visible");
            //     if (searchIsVisible)
            //         vccsupport.toggleSearch();
            // },
            // searchBoxBehaviour: function () {
            //     var searchButton = $('.search-box-button');
            //     if (vcc.isMobileViewport) {
            //         if (vccsupport.isRetinaDisplay())
            //             searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/mobile/retina/search_20px.png");
            //         else
            //             searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/mobile/search_20px.png");
            //     }
            //     else {
            //         var hasLargeSearchBox = $(".large-search-box").length > 0;
            //         if (vccsupport.isRetinaDisplay()) {
            //             if (hasLargeSearchBox)
            //                 searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/retina/search.png");
            //             else
            //                 searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/retina/search_16px.png");
            //         }
            //         else {
            //             if (hasLargeSearchBox)
            //                 searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/search.png");
            //             else if (vccsupport.ie6)
            //                 searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/search_16px.gif");
            //             else
            //                 searchButton.attr("src", "/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/images/icons/search_16px.png");
            //         }
            //     }
    
    
            //     var defaultText = $('input[id$=hiddenDefaultText]').val();
            //     if ($(".search-box-text").val() == defaultText) {
            //         $(".search-box-text").addClass("default-text");
            //         $('.search-box-button').addClass('disabled');
            //         $('.search-box-button').on('click', function () {
            //             return false;
            //         });
            //     }
            //     else if ($(".search-box-text").val() != "") {
            //         $('.search-box-button').removeClass('disabled');
            //         $('.search-box-button').off('click');
            //     }
            //     $('.search-box-text').on('click', function () {
            //         if ($(this).val() == defaultText) {
            //             $(this).removeClass("default-text");
            //             $(this).val("");
            //         }
            //         $('#search-box').addClass('focus');
            //     });
    
            //     $('.search-box-text').keydown(function () {
            //         if ($(this).val() == defaultText) {
            //             $(this).removeClass("default-text");
            //             $(this).val("");
            //         }
            //         $('#search-box').addClass('focus');
            //     });
    
            //     $(".search-box-text").blur(function () {
            //         if ($(this).val() == "") {
            //             $(this).addClass("default-text");
            //             $(this).val(defaultText);
            //         }
            //         $('#search-box').removeClass('focus');
            //     });
    
            //     $(".search-box-text").mouseout(function () {
            //         if ($(this).val() == "" || $(this).val() == defaultText) {
            //             $('.search-box-button').on('click', function () {
            //                 return false;
            //             });
            //             $('.search-box-button').addClass('disabled');
            //         }
            //         if ($(this).val() != "" && $(this).val() != defaultText) {
            //             $('.search-box-button').off('click');
            //             $('.search-box-button').removeClass('disabled');
            //         }
            //     });
    
            //     $(".search-box-text").keyup(function () {
            //         if ($(this).val() == "") {
            //             $('.search-box-button').addClass('disabled');
            //             $('.search-box-button').on('click', function () {
            //                 return false;
            //             });
            //         } else {
            //             $('.search-box-button').off('click');
            //             $('.search-box-button').removeClass('disabled');
            //         }
            //     });
    
            //     if ($(".large-search-box").length > 0 && (vccsupport.ie6 || vccsupport.ie7)) {
            //         var search = $("#search-area"), controls = $("#search-controls");
            //         var margin = (search.height() - controls.height()) / 2;
            //         controls.css("margin-top", margin);
            //     }
    
            //     var searchBtn = $("#search-button");
            //     if (!vccsupport.hasEventHandler(searchBtn, "click")) {
            //         searchBtn.on("click", function (e) {
            //             if (vccsupport.isDesktopMode()) {
            //                 e.preventDefault();
            //                 vccsupport.toggleSearch();
            //             }
            //         });
            //     }
    
    
            //     // On page load, check if search field is visible and then style the search button in topnav accordingly
            //     if ($("#search-controls").is(":visible"))
            //         $("#search-button-image").addClass("close-search");
            // },
            // openWindow: function (sURL, sName, sOptions, bDoNotReturnWindow) {
            //     if (!sOptions) sOptions = "location=yes,resizable=yes,scrollbars=yes,status=yes,toolbar=yes,";
            //     else {
            //         //parse the sOptions variable to get width and height
            //         var aWidth = sOptions.match(/width=[0-9]+/i);
            //         var aHeight = sOptions.match(/height=[0-9]+/i);
            //         if (aWidth != null) {
            //             //Center window horizontally
            //             var iWidth = aWidth[0].substring(aWidth[0].lastIndexOf("=") + 1);
            //             var x = (screen.width - iWidth) / 2;
            //             x = (x < 0) ? 0 : x;
            //             sOptions += ",left=" + x;
            //         }
            //         if (aHeight != null) {
            //             //Center window vertically
            //             var iHeight = aHeight[0].substring(aHeight[0].lastIndexOf("=") + 1);
            //             var y = (screen.height - iHeight) / 2;
            //             y = (y < 0) ? 0 : y;
            //             sOptions += ",top=" + y;
            //         }
            //     }
            //     var popup = (window.open(sURL, sName, sOptions));
            //     if (!bDoNotReturnWindow)
            //         return popup;
            // },
            isTouchDevice: function () {
                return !!('ontouchstart' in window) || navigator.userAgent.match(/Touch/i) != null;
            },
            isRetinaDisplay: function () {
                if (window.matchMedia) {
                    var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
                    if ((mq && mq.matches) || window.devicePixelRatio > 1) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
            },
            // /*
            //  * Returns the value of a query string parameter, or null if it does not exist
            //  */
            // getParameter: function (parameterName) {
            //     if (!this.urlParams) {
            //         this.urlParams = {};
            //         var e,
            //             a = /\+/g, // Regex for replacing addition symbol with a space
            //             r = /([^&;=]+)=?([^&;]*)/g,
            //             d = function (s) {
            //                 return decodeURIComponent(s.replace(a, " "));
            //             },
            //             q = window.location.search.substring(1);
    
            //         while (e = r.exec(q))
            //             this.urlParams[d(e[1].toLowerCase())] = d(e[2]);
            //     }
            //     parameterName = parameterName.toLowerCase();
            //     var param = this.urlParams[parameterName];
            //     return param ? param : null;
            // },
            // createCookie: function (cname, cvalue, exdays, path) {
            //     var d = new Date(), expires, value;
            //     d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
            //     expires = "expires=" + d.toGMTString();
            //     value = cname + "=" + cvalue + "; " + expires;
            //     if (this.is(this.jstypes.string, path)) {
            //         value += "; path=" + path;
            //     }
            //     document.cookie = value;
            // },
            // getCookie: function (cookieName, keyName) {
            //     var name = cookieName + "=";
            //     var items = document.cookie.split(';');
            //     for (var i = 0; i < items.length; i++) {
            //         var cook = items[i];
            //         while (cook.charAt(0) == ' ')
            //             cook = cook.substring(1);
            //         if (cook.indexOf(name) == 0) {
            //             if (keyName) {
            //                 var cookieVal = cook.substring(cook.indexOf("=") + 1)
            //                 var subItems = cookieVal.split('&');
            //                 for (var j = 0; j < subItems.length; j++) {
            //                     var arSubItem = subItems[j].split("=");
            //                     if (arSubItem[0] == keyName)
            //                         return arSubItem[1];
            //                 }
            //             }
            //             else
            //                 return cook.substring(name.length, cook.length);
            //         }
            //     }
            //     return null;
            // },
            // ensureMarketCookie: function () {
            //     var c = this.getCookie("vccsupport.market");
            //     if (!c) {
            //         if (this.market && this.market.length) {
            //             this.createCookie("vccsupport.market", this.market, 365, "/");
            //         }
            //     }
            // },
            // setMarketCookie: function () {
            //     var c = this.getCookie("vccsupport.market.set"), m;
            //     if (c && this.market) {
            //         m = this.market.toLowerCase()
            //         if (c.toLowerCase() === m) {
            //             this.createCookie("vccsupport.market", m, 365, "/");
            //             this.createCookie("vccsupport.market.set", "", -1, "/");
            //         }
            //     }
            // },
            // redirectWithModelParameters: function (url, modelCode, modelYear, modelWeek) {
            //     var uri = new this.Uri(url);
            //     uri.parameters[this.MODEL_CODE] = modelCode;
            //     uri.parameters[this.MODEL_YEAR] = modelYear;
            //     uri.parameters[this.STRUCTURE_WEEK] = modelWeek;
            //     location.href = uri.toString(true);
            // },
            // getCurrentModel: function () {
            //     var modelCode = vccsupport.getParameter(vccsupport.MODEL_CODE) || vccsupport.getCookie(vccsupport.CAR_COOKIE_NAME, vccsupport.MODEL_CODE);
            //     var modelYear = vccsupport.getParameter(vccsupport.MODEL_YEAR) || vccsupport.getCookie(vccsupport.CAR_COOKIE_NAME, vccsupport.MODEL_YEAR);
            //     var structureWeek = vccsupport.getParameter(vccsupport.STRUCTURE_WEEK) || vccsupport.getCookie(vccsupport.CAR_COOKIE_NAME, vccsupport.STRUCTURE_WEEK);
            //     if (modelCode && modelYear && structureWeek) {
            //         var currentModel = {};
            //         currentModel[vccsupport.MODEL_CODE] = modelCode.toLowerCase();
            //         currentModel[vccsupport.MODEL_YEAR] = modelYear;
            //         currentModel[vccsupport.STRUCTURE_WEEK] = structureWeek.toLowerCase();
            //         return currentModel;
            //     }
            //     return null;
            // },
            // getCurrentModelQueryString: function () {
    
            //     var currentModel = this.getCurrentModel();
            //     if (currentModel == null) {
            //         return;
            //     }
            //     var qs = "";
    
            //     // Model code
            //     if (currentModel[vccsupport.MODEL_CODE]) {
            //         qs = qs + (qs == "" ? "" : ("&")) + vccsupport.MODEL_CODE + "=" + currentModel[vccsupport.MODEL_CODE];
            //     }
    
            //     // Model year
            //     if (currentModel[vccsupport.MODEL_YEAR]) {
            //         qs = qs + (qs == "" ? "" : ("&")) + vccsupport.MODEL_YEAR + "=" + currentModel[vccsupport.MODEL_YEAR];
            //     }
    
            //     // Structure week
            //     if (currentModel[vccsupport.STRUCTURE_WEEK]) {
            //         qs = qs + (qs == "" ? "" : ("&")) + vccsupport.STRUCTURE_WEEK + "=" + currentModel[vccsupport.STRUCTURE_WEEK];
            //     }
    
            //     qs = (qs == "") ? qs : "?" + qs;
    
            //     return qs;
            // },
            // getCurrentModelUrlWithQueryString: function () {
            //     var url = document.URL.split("?")[0];
            //     return url + this.getCurrentModelQueryString();
            // },
            // getAlert: function (onLoad) {
            //     this.callNotificationService("GetAlert", "VccSupportAlerts", function (e, data) {
            //         var wrapper = $("<div></div>"), el = $("<div></div>");
            //         wrapper.append(el);
    
            //         // Start date
            //         if (data.when && data.when.length) {
            //             el.append("<p>{0}</p>".format(data.when));
            //         }
    
            //         // message
            //         el.append("<p>{0}</p>".format(data.message));
    
            //         // body text
            //         if (data.text && data.text.length) {
            //             el.append("<p>{0}</p>".format(data.text));
            //         }
    
            //         var maxHeight = $(window).height() * 0.6;
            //         wrapper.css({
            //             backgroundColor: "#fff",
            //             boxSizing: "border-box",
            //             maxHeight: maxHeight,
            //             margin: "40px 0 30px",
            //             padding: "0 40px 0",
            //             overflow: "hidden",
            //             overflowY: "auto"
            //         });
    
            //         vccsupport.alertOverlay.show(wrapper, function () {
            //             wrapper.fadeOut(300, function () {
            //                 wrapper.remove();
            //             });
            //             vccsupport.getAdvisory();
            //         });
            //     }, onLoad);
            // },
            // getAdvisory: function (onLoad) {
            //     this.callNotificationService("GetAdvisory", "VccSupportAdvisories", null, onLoad);
            // },
            // callNotificationService: function (method, cookieName, onClick, onLoad) {
            //     if (!this.is(this.jstypes.string, method) || method.length === 0) {
            //         throw new TypeError("method");
            //     }
            //     if (!this.is(this.jstypes.string, cookieName) || cookieName.length === 0) {
            //         throw new TypeError("cookieName");
            //     }
    
            //     var market = this.market;
            //     $.ajax({
            //         url: "/" + market + "/_vti_bin/NotificationService.svc/" + method,
            //         type: "GET",
            //         contentType: "application/json; charset=utf-8",
            //         success: function (data) {
            //             var el,
            //                 id,
            //                 ids = [],
            //                 linkText,
            //                 link,
            //                 span,
            //                 height,
            //                 cvalue,
            //                 cname = cookieName,
            //                 cpath = "/" + market + "/",
            //                 wasShown = false;
    
            //             if (data && vccsupport.is(vccsupport.jstypes.object, data)) {
            //                 id = data.id;
            //                 linkText = data.message;
            //                 cvalue = vccsupport.getCookie(cname);
            //                 if (cvalue && cvalue.length > 0) {
            //                     ids = cvalue.split(",");
            //                 }
            //                 if ($.inArray(id, ids) === -1) {
            //                     el = $("#advisory");
            //                     link = el.find(".advisory-link");
            //                     if (link.length === 1) {
            //                         // Set item found flag, to inform callee that an item was shown
            //                         wasShown = true;
            //                         span = link.find("span");
            //                         if (vccsupport.isDesktopMode()) {
            //                             height = 60;
            //                             linkText = vccsupport.truncateString(linkText.split(" "), 820, span.css("fontSize"));
            //                             span.text(linkText);
            //                             el.addClass("active");
            //                             link.off("click").on("click", function (e) {
            //                                 e.preventDefault();
            //                                 ids.push(id);
            //                                 vccsupport.createCookie(cname, ids.join(","), 365, cpath);
            //                                 el.find(".advisory").fadeOut(300, "swing", function () {
            //                                     el.find(".background").animate({ height: 0 }, 300);
            //                                     el.animate({ height: 0 }, 300, function () {
            //                                         el.removeClass("active").removeAttr("style");
            //                                         if (vccsupport.is(vccsupport.jstypes.func, onClick)) {
            //                                             onClick.call(link[0], e, data);
            //                                         }
            //                                         else {
            //                                             window.location = link.attr("href");
            //                                         }
            //                                     });
            //                                 });
            //                                 return false;
            //                             });
            //                             el.find(".close-advisory").click(function (e) {
            //                                 ids.push(id);
            //                                 vccsupport.createCookie(cname, ids.join(","), 365, cpath);
            //                                 el.find(".advisory").fadeOut(300, "swing", function () {
            //                                     el.find(".background").animate({ height: 0 }, 300);
            //                                     el.animate({ height: 0 }, 300, function () {
            //                                         el.removeClass("active").removeAttr("style");
            //                                     });
            //                                 });
            //                             });
            //                             el.find(".background").animate({ height: height }, 500, function () {
            //                                 el.find(".advisory").fadeIn(500);
            //                             });
            //                         }
            //                         else {
            //                             span.text(linkText);
            //                             link.off("click").on("click", function (e) {
            //                                 e.preventDefault();
            //                                 ids.push(id);
            //                                 vccsupport.createCookie(cname, ids.join(","), 365, cpath);
            //                                 el.find(".advisory").fadeOut(300, "swing", function () {
            //                                     el.animate({ height: 0 }, 300, function () {
            //                                         el.hide();
            //                                         if (vccsupport.is(vccsupport.jstypes.func, onClick)) {
            //                                             onClick.call(link[0], e, data);
            //                                         }
            //                                         else {
            //                                             window.location = link.attr("href");
            //                                         }
            //                                     });
            //                                 });
            //                                 return false;
            //                             });
            //                             el.find(".close-advisory").click(function (e) {
            //                                 ids.push(id);
            //                                 vccsupport.createCookie(cname, ids.join(","), 365, cpath);
            //                                 el.find(".advisory").fadeOut(300, "swing", function () {
            //                                     el.animate({ height: 0 }, 300, function () {
            //                                         el.hide();
            //                                     });
            //                                 });
            //                             });
            //                             height = el.height();
            //                             el.css({
            //                                 display: "block",
            //                                 height: 0,
            //                                 position: "relative",
            //                                 visibility: "visible"
            //                             });
            //                             el.animate({ height: height }, 500, function () {
            //                                 var el2 = el.find(".advisory");
            //                                 el.css({ height: "auto" });
            //                                 el2.css({
            //                                     display: "none",
            //                                     visibility: "visible"
            //                                 });
            //                                 el2.fadeIn(500);
            //                             });
            //                         }
            //                     }
            //                 }
            //             }
    
            //             if (vccsupport.is(vccsupport.jstypes.func, onLoad)) {
            //                 onLoad.call(vccsupport, wasShown);
            //             }
            //         }
            //     });
            // },
            // truncateString: function (words, maxWidth, fontSize) {
            //     var sp = document.createElement("span"),
            //         $sp = $(sp),
            //         text = words.join(" "),
            //         body = $("body"), w;
            //     if (!fontSize) {
            //         fontSize = body.css("fontSize");
            //     }
            //     $sp.css({
            //         visibility: "hidden",
            //         fontSize: fontSize
            //     });
            //     body.append($sp);
            //     w = $sp.text(text).width();
            //     while (w > maxWidth) {
            //         words.pop();
            //         text = words.join(" ") + " ...";
            //         w = $sp.text(text).width();
            //     }
            //     $sp.remove();
            //     return text;
            // },
            // rateThisPage: function (url, sMarket, positive) {
            //     var formDigestHeader = { "X-RequestDigest": $("input[name='__REQUESTDIGEST']").val() };
    
            //     $.ajax({
            //         url: "/" + sMarket + "/_vti_bin/RatingService.svc/RatePage",
            //         type: "POST",
            //         headers: formDigestHeader,
            //         contentType: "application/json; charset=utf-8",
            //         dataType: "json",
            //         processData: false,
            //         data: "{\"url\":\"" + url + "\",\"rating\":" + positive.toString() + "}"
            //     });
            // },
            // rateThisPageOption: function (url, sMarket, option) {
            //     var formDigestHeader = { "X-RequestDigest": $("input[name='__REQUESTDIGEST']").val() };
    
            //     $.ajax({
            //         url: "/" + sMarket + "/_vti_bin/RatingService.svc/RatePageOption",
            //         type: "POST",
            //         headers: formDigestHeader,
            //         contentType: "application/json; charset=utf-8",
            //         dataType: "json",
            //         processData: false,
            //         data: "{\"url\":\"" + url + "\",\"option\":" + option.toString() + "}"
            //     });
            // },
            // showRateThisPage: function () {
            //     var rtp, m = this.market, cookie, p, url,
            //         uri = new vccsupport.Uri(document.URL),
            //         params = [this.ARTICLE, this.MODEL_CODE, this.MODEL_YEAR, this.STRUCTURE_WEEK];
    
            //     // Only keep what we're interested in
            //     uri.hash = "";
            //     for (p in uri.parameters) {
            //         if ($.inArray(p.toLowerCase(), params) === -1) {
            //             uri.parameters[p] = undefined;
            //         }
            //     }
    
            //     // Get relative article URL
            //     url = uri.toString(true);
    
            //     // Check if cookie exists
            //     cookie = vccsupport.getCookie(url);
            //     if (!cookie && m) {
            //         rtp = $("#ratethispage").show();
            //         $("#ratethispagebuttons").fadeIn("fast");
            //         rtp.find(".ratethispageyesbutton").off("click").on("click", function () {
            //             vccsupport.createCookie(url, true, 1);
            //             vccsupport.rateThisPage(url, m, true);
            //             $("#ratethispagebuttons").css("display", "none");
            //             $("#responsecontainer,#ratingresponse-yes").fadeIn('fast');
            //         });
            //         rtp.find(".ratethispagenobutton").off("click").on("click", function () {
            //             var tohide, toshow = $("#responsecontainer,#ratingresponse-no,#ratingresponse-options");
            //             if (toshow.length === 3) {
            //                 tohide = $("#ratethispagebuttons,#ratingresponse");
            //             }
            //             else {
            //                 toshow = $("#responsecontainer");
            //                 tohide = $("#ratethispagebuttons");
            //             }
            //             vccsupport.createCookie(url, true, 1);
            //             vccsupport.rateThisPage(url, m, false);
            //             tohide.hide();
            //             toshow.fadeIn('fast');
            //         });
            //         $("#ratingresponse-optionsbutton").off("click").on("click", function () {
            //             var option = rtp.find(".ratingresponse-option input[name='ratingresponse-option']:checked").val();
            //             if (option && option.length) {
            //                 vccsupport.rateThisPageOption(url, m, option);
            //                 $("#ratingresponse-no,#ratingresponse-options").fadeOut('fast', function () {
            //                     $("#ratingresponse").fadeIn('fast');
            //                 });
            //             }
            //         });
            //     }
            // },
            // /* ## Overrlay  ## */
            // showOverlay: function (oOnClickFunction, sOverlayHtml, iOverlayWidth, iOverlayHeight, bDisableBorders, iFixedMarginFromTop, bImage, dOpacity, bAbsolutePosition) {
            //     if (!this.is(this.jstypes.func, oOnClickFunction))
            //         oOnClickFunction = vccsupport.hideOverlay;
    
            //     var oOverlay = $("#overlay");
            //     if (oOverlay.length === 0) {
            //         oOverlay = $("<div id=\"overlay\" />").appendTo(document.body);
            //         oOverlay.css({
            //             "opacity": "0",
            //             "position": (vccsupport.ie6 || bAbsolutePosition) ? "absolute" : "fixed",
            //             "top": "0px",
            //             "background-color": "black"
            //         });
            //         oOverlay.click(function () {
            //             oOnClickFunction();
            //         });
            //     }
    
            //     vccsupport.resizeOverlay();
            //     if (dOpacity && dOpacity !== null) {
            //         oOverlay.fadeTo(0, dOpacity);
            //     } else {
            //         oOverlay.fadeTo(0, 0.75);
            //     }
            //     oOverlay.show();
    
            //     if (sOverlayHtml == null)
            //         return;
    
            //     var oOverlayContainer = $("#overlay-container");
            //     if (oOverlayContainer.length === 0) {
            //         oOverlayContainer = $("<div id=\"overlay-container\" />").appendTo(document.body);
            //     }
            //     oOverlayContainer.width((iOverlayWidth) ? iOverlayWidth : "auto");
            //     oOverlayContainer.height((iOverlayHeight) ? iOverlayHeight : "auto");
            //     oOverlayContainer.html(sOverlayHtml + "<a href=\"#\" id=\"overlay-closebutton\"></a>");
            //     oOverlayContainer.css({
            //         "border": "black",
            //         "background-color": "white"
            //     });
    
            //     $("#overlay-closebutton").click(function () {
            //         oOnClickFunction();
            //         return false;
            //     });
    
            //     if (vccsupport.is(vccsupport.jstypes.boolean, bImage) && bImage === true) {
            //         oOverlayContainer.find("img").load(function () {
            //             oOverlayContainer.fadeIn('slow', function () {
            //                 // wait for image to get layout
            //                 setTimeout(function () { vccsupport.center(oOverlayContainer, true, vccsupport.centerLightBoxVertically, iFixedMarginFromTop, bAbsolutePosition); }, 20);
            //             });
            //         });
            //     } else {
            //         oOverlayContainer.fadeIn('slow', vccsupport.center(oOverlayContainer, true, vccsupport.centerLightBoxVertically, iFixedMarginFromTop, bAbsolutePosition));
            //     }
    
            //     $(window).on("resize", vccsupport.handleOverlayWhenResized);
            // },
            // center: function (elm, bHorizontally, bVertically, iFixedMarginFromTop, bAbsolutePosition) {
            //     if (elm === null) {
            //         return;
            //     }
    
            //     if (vccsupport.ie6 || bAbsolutePosition) {
            //         $(elm).css("position", "absolute");
            //     }
            //     else {
            //         $(elm).css("position", "fixed");
            //     }
    
            //     if (bHorizontally) {
            //         $(elm).css({
            //             "left": ($(window).width() - $(elm).outerWidth()) / 2 + $(window).scrollLeft()
            //         });
            //     }
    
            //     if (iFixedMarginFromTop) {
            //         if (vccsupport.ie6 || bAbsolutePosition) {
            //             $(elm).css({
            //                 "top": $(window).scrollTop() + iFixedMarginFromTop
            //             });
            //         }
            //         else {
            //             $(elm).css({
            //                 "top": iFixedMarginFromTop.toString() + "px"
            //             });
            //         }
            //     } else if (bVertically) {
            //         if (vccsupport.ie6 || bAbsolutePosition) {
            //             $(elm).css({
            //                 "top": ($(window).height() - $(elm).height()) / 2 + $(window).scrollTop() - 15
            //             });
            //         }
            //         else {
            //             $(elm).css({
            //                 "top": ($(window).height() - $(elm).height()) / 2
            //             });
            //         }
            //     }
            // },
            // resizeOverlay: function () {
            //     var oOverlay = document.getElementById("overlay");
            //     if (oOverlay == null)
            //         return;
            //     var arrayPageSize = vccsupport.getPageSize();
            //     $(oOverlay).css({
            //         "width": arrayPageSize[0],
            //         "height": arrayPageSize[1]
            //     });
            // },
            // hideOverlay: function () {
            //     var oc = $("#overlay-container");
            //     $(window).off("resize", vccsupport.handleOverlayWhenResized);
            //     $("#overlay").fadeOut(500, function () { $(this).removeClass("menu-overlay"); });
            //     if (oc.find("#flashLightBoxContainer").length > 0) {
            //         swfobject.removeSWF("flashLightBoxContainer");
            //     } else if (oc.find("#large").length > 0) {
            //         swfobject.removeSWF("large");
            //     }
            //     oc.replaceWith("<div id=\"overlay-container\"></div>");
            //     oc = $("#overlay-container");
            //     oc.hide();
            //     vccsupport.centerLightBoxVertically = false;
            // },
            // showSimpleOverlay: function () {
            //     var oOverlay = $("#overlay");
            //     if (oOverlay.length === 0) {
            //         oOverlay = $("<div id=\"overlay\" />").appendTo(document.body);
            //         oOverlay.css({
            //             "opacity": "0",
            //             "position": (vccsupport.ie6) ? "absolute" : "fixed",
            //             "top": "65px",
            //             "background-color": "black"
            //         });
            //     }
    
            //     vccsupport.resizeOverlay();
            //     oOverlay.fadeTo(0, 0.75);
            //     oOverlay.show();
            // },
            // hideSimpleOverlay: function () {
            //     $("#overlay").fadeOut(500);
            // },
            // getPageSize: function () {
            //     var xScroll, yScroll;
            //     if (window.innerHeight && window.scrollMaxY) {
            //         xScroll = window.innerWidth + window.scrollMaxX;
            //         yScroll = window.innerHeight + window.scrollMaxY;
            //     } else if (document.body.scrollHeight > document.body.offsetHeight) {
            //         xScroll = document.body.scrollWidth;
            //         yScroll = document.body.scrollHeight;
            //     } else {
            //         xScroll = document.body.offsetWidth;
            //         yScroll = document.body.offsetHeight;
            //     }
            //     var windowWidth, windowHeight;
    
            //     if (self.innerHeight) { // all except Explorer
            //         windowWidth = (document.documentElement.clientWidth) ? document.documentElement.clientWidth : self.innerWidth;
            //         windowHeight = self.innerHeight;
            //     } else if (document.documentElement && document.documentElement.clientHeight) { // Explorer 6 Strict Mode
            //         windowWidth = document.documentElement.clientWidth;
            //         windowHeight = document.documentElement.clientHeight;
            //     } else if (document.body) { // other Explorers
            //         windowWidth = document.body.clientWidth;
            //         windowHeight = document.body.clientHeight;
            //     }
    
            //     pageHeight = (yScroll < windowHeight) ? windowHeight : yScroll;
            //     pageWidth = (xScroll < windowWidth) ? windowWidth : xScroll;
    
            //     arrayPageSize = new Array(pageWidth, pageHeight, windowWidth, windowHeight);
            //     return arrayPageSize;
            // },
            // handleOverlayWhenResized: function () {
            //     vccsupport.resizeOverlay();
            //     vccsupport.center(document.getElementById("overlay-container"), true, vccsupport.centerLightBoxVertically);
            // },
            // playMovie: function (movieUrl, videoSubtitleUrl, element) {
            //     var video = $("<div><video id='videoContainer' width='675' height='380' class='video-js vjs-default-skin'></video></div>");
            //     if (element) {
            //         video.append(element);
            //     }
            //     this.videoOverlay.show(video, function () {
            //         var player = _V_('videoContainer');
            //         player.pause();
            //         if (player.techName && player.techName === 'html5') {
            //             player.tag.src = '';
            //             player.tech.removeTriggers();
            //         }
            //         player.destroy();
            //     });
            //     this.setUpVideo('videoContainer', movieUrl, videoSubtitleUrl);
            // },
            // setUpVideo: function (videoId, videoUrl, videoSubtitleUrl) {
            //     var flashSwf = '/_layouts/15/VolvoCars.SharePoint.Features.SupportSite/js/lib/videojs/video-js.swf';
    
            //     if (videoUrl) {
    
            //         var videoOptions = {};
            //         videoOptions.controls = 'controls';
            //         videoOptions.autoplay = false;
            //         videoOptions.poster = '';
            //         if (videoSubtitleUrl && videoSubtitleUrl.length > 1) {
            //             videoOptions.tracks = [{
            //                 kind: 'subtitles',
            //                 src: videoSubtitleUrl,
            //                 srclang: 'en',
            //                 label: 'Default',
            //                 'default': 'default'
            //             }];
            //         }
    
            //         _V_.options.flash.swf = flashSwf;
    
            //         this.player = _V_(videoId, videoOptions);
            //         this.player.src([{
            //             type: 'video/mp4',
            //             src: videoUrl
            //         }]);
            //         this.player.play();
            //     }
            //     $('#video-container video').attr('poster', '');
            // },
            // ie67fixer: function () {
            //     // Fix tagged elements
            //     $(".ie67fix").each(function (index, item) {
            //         // Fix vertical align middle if set
            //         var attrVerticalAlign = $(item).css('vertical-align');
            //         if (typeof attrVerticalAlign !== typeof undefined && attrVerticalAlign !== false && attrVerticalAlign == "middle") {
            //             vccsupport.verticallyAlignMiddle($(item));
            //         }
            //         // Hovering
            //         if ($(item).hasClass("ie6fix-hover")) {
            //             vccsupport.addHoverClass($(item));
            //         }
            //     });
            // },
            // /*
            // * Add an element to the group
            // * @param {Object}  jqElement - jQuery element that should be vertically centered
            // */
            // verticallyAlignMiddle: function (jqElement) {
            //     var heightParent = jqElement.parent().height() - 1;
            //     var heightElement = jqElement.outerHeight();
            //     var topMargin = ((heightParent - heightElement) / 2) + "px";
            //     jqElement.css('margin-top', topMargin);
            // },
            // /*
            // * Add an element to the group
            // * @param {Object}  jqElement - jQuery element that should be vertically centered
            // */
            // addHoverClass: function (jqElement) {
            //     jqElement.hover(
            //         function () {
            //             $(this).addClass('hover');
            //         }, function () {
            //             $(this).removeClass('hover');
            //         }
            //     );
            // },
            touchDoubleClickFix: function () {
                if (this.isTouchDevice() && !this.isAndroidTablet()) {
                    $("a.handleTouch").on(
                        {
                            'touchstart': function () {
                                $("a.handleTouch").removeClass("touched");
                            },
                            'touchmove': function () {
                                $("a.handleTouch").addClass("touched");
                            },
                            'touchend': function () {
                                if (!$(this).hasClass('touched')) {
                                    setTimeout(function () { $(this).click(); }, 500);
                                }
                            }
                        }
                    );
                }
            },
            // extend: function (namespace, obj) {
            //     var i, len, n, namespaces, parent;
            //     if (vccsupport.is(vccsupport.jstypes.string, namespace) && vccsupport.is(vccsupport.jstypes.object, obj)) {
            //         // Set default starting namespace
            //         parent = vccsupport;
            //         namespaces = namespace.split(".")
            //         if (namespaces[0] === "vcc") {
            //             // Change starting namespace
            //             parent = vcc;
            //             namespaces.splice(0, 1);
            //         }
            //         else if (namespaces[0] === "vccsupport") {
            //             // Remove default starting namespace;
            //             namespaces.splice(0, 1);
            //         }
            //         // Ensure all namespaces exists
            //         len = namespaces.length;
            //         for (i = 0; i < len; i++) {
            //             n = namespaces[i];
            //             if (!vccsupport.is(vccsupport.jstypes.object, parent[n])) {
            //                 if (!vccsupport.is("undefined", parent[n])) {
            //                     throw new TypeError(n + " exists and is not of type Object");
            //                 }
            //                 parent[n] = {};
            //             }
            //             parent = parent[n];
            //         }
            //         // Register object in parent namespace
            //         parent = $.extend(true, parent, obj);
            //     }
            // },
            // hasEventHandler: function (element, eventType) {
            //     if (element.length > 0) {
            //         var events = $._data(element.get(0), "events");
            //         var hasEvent = false;
            //         if (events != undefined) {
            //             $.each(events, function (type, event) {
            //                 if (type == eventType) {
            //                     hasEvent = true;
            //                 }
            //             });
            //         }
            //     }
            //     return hasEvent;
            // }
        };

        this.vccsupport.Uri = this.initVccSupportUri;
    }

    initVccSupportUri(url) {
        var parse = function (url) {
            var u = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@]*)(?::([^:@]*))?)?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, // regex for parsing URL
            a = /\+/g, // Regex for replacing addition symbol with a space
            r = /([^&;=]+)=?([^&;]*)/g, // regex for parsing query string
            d = function (s) {
                return decodeURIComponent(s.replace(a, " "));
            },
            p = {},
            absolute, matches, prot, host, port, isDefaultPort, path, search, hash, param;

            // Require absolute URI or URL
            if (!url || url.length === 0) {
                return url;
            }

            if (url[0] === '/') {
                prot = location.protocol;
                if (prot[prot.length - 1] !== ':') {
                    prot += ":";
                }
                absolute = prot + "//" + location.hostname;
                port = parseInt(location.port, 10);
                if (port && port !== 80 && port !== 443) {
                    absolute += ":" + port;
                }
                absolute += url;
            }
            else {
                absolute = url;
            }

            // Run regex on URL
            matches = u.exec(absolute);

            // get matches
            prot = matches[1] || "http"; // protocol
            host = matches[6]; // hostname
            port = parseInt(matches[7], 10); // port
            path = matches[9]; // pathname
            search = matches[12]; // query string
            hash = matches[13]; // hash

            // Check if default port
            isDefaultPort = false;
            if (port) {
                if (prot.toLowerCase() === "http" && port === 80) {
                    isDefaultPort = true;
                }
                else if (prot.toLowerCase() === "https" && port === 443) {
                    isDefaultPort = true;
                }
            }
            else {
                if (prot.toLowerCase() === "http") {
                    port = 80;
                    isDefaultPort = true;
                }
                else if (prot.toLowerCase() === "https") {
                    port = 443;
                    isDefaultPort = true;
                }
            }

            // Remove ? from query string
            if (search && search[0] === '?') {
                search = search.substring(1);
            }

            // Get parameters
            var e;
            while (e = r.exec(search || "")) {
                p[d(e[1])] = d(e[2]);
            }

            return {
                protocol: prot,
                hostname: host,
                port: port,
                isDefaultPort: isDefaultPort,
                pathname: path,
                search: search,
                hash: hash,
                parameters: p
            };
        };

        var Uri = function (url) {
            var o;
            if (!(this instanceof Uri)) {
                return new Uri(url);
            }
            if (!url || !url.length) {
                throw new TypeError("The parameter is not a valid URL");
            }
            o = parse(url);
            this.protocol = o.protocol;
            this.hostname = o.hostname;
            this.port = o.port;
            this.isDefaultPort = o.isDefaultPort;
            this.pathname = o.pathname;
            this.search = o.search;
            this.hash = o.hash;
            this.parameters = o.parameters;
        };

        Uri.prototype.pathAndQuery = function () {
            var url = "",
            s = "?",
            q, p, param;

            if (this.pathname) {
                url += this.pathname;
            }

            if (this.parameters) {
                q = "";
                for (p in this.parameters) {
                    param = this.parameters[p];
                    if (param && param.length) {
                        q += s + p + "=" + encodeURIComponent(param);
                        s = "&";
                    }
                }
                url += q;
            }

            if (this.hash) {
                url += "#" + this.hash;
            }

            return url;
        };

        Uri.prototype.toString = function (updateQueryString) {
            var url = "",
            s = "?",
            q, p, param;

            // ensure protocol and hostname were found by regex when parsing URL
            if (this.protocol && this.protocol.length && this.hostname && this.hostname.length) {
                url = this.protocol + "://" + this.hostname;

                if (!this.isDefaultPort) {
                    url += ":" + this.port;
                }
            }

            if (this.pathname) {
                url += this.pathname;
            }

            if (updateQueryString) {
                if (this.parameters) {
                    q = "";
                    for (p in this.parameters) {
                        param = this.parameters[p];
                        if (typeof (param) !== "undefined" && param !== null) {
                            q += s + p + "=" + encodeURIComponent(param);
                            s = "&";
                        }
                    }
                    url += q;
                }
            }
            else {
                if (this.search) {
                    url += "?" + this.search;
                }
            }

            if (this.hash) {
                url += "#" + this.hash;
            }

            return url;
        };

        return Uri(url);
    }
    
    
        // (function ($) {
    
        //     var pluginName = "forumBox",
        //         defaults = {
        //             callback: null,
        //             url: "/_vti_bin/FeedReaderService.svc/ForumFeed",
        //             forumId: null,
        //             start: 0,
        //             take: 3,
        //             titleRows: 2,
        //             summaryRows: 2,
        //             hideDescription: false
        //         };
    
        //     function ForumBox(element, options) {
        //         this.element = element;
        //         this.options = $.extend({}, defaults, options);
        //         this.init();
        //     };
    
        //     $.extend(ForumBox.prototype, {
        //         init: function () {
        //             this.load();
        //         },
        //         load: function () {
        //             var me = this, uri = new vccsupport.Uri(this.options.url);
        //             uri.parameters["forumId"] = this.options.forumId;
        //             uri.parameters["s"] = this.options.start.toString();
        //             uri.parameters["t"] = this.options.take.toString();
    
        //             $.ajax({
        //                 url: uri.toString(true),
        //                 contentType: "application/json; charset=utf-8",
        //                 type: "GET",
        //                 success: function (data) {
        //                     me.data = data;
        //                     me.render();
        //                 },
        //                 error: function () {
        //                     me.render();
        //                 }
        //             });
        //         },
        //         render: function () {
        //             var el = $(this.element),
        //                 p = el.find(".forum-items"),
        //                 show = false,
        //                 i, title, ext;
        //             p.empty();
        //             if (this.data) {
        //                 if (this.data.elementExtensions) {
        //                     for (i in this.data.elementExtensions) {
        //                         ext = this.data.elementExtensions[i];
        //                         if (ext.Key === "vcctitle") {
        //                             title = ext.Value;
        //                         }
        //                     }
        //                 }
    
        //                 for (i in this.data.items) {
        //                     if (this.options.hideDescription)
        //                         this.data.items[i].description = "";
    
        //                     $("#forumBoxTmpl").tmpl(
        //                         $.extend({
        //                             category: title || this.data.title,
        //                             categoryLink: this.data.link,
        //                             titleRows: this.options.titleRows,
        //                             summaryRows: this.options.summaryRows
        //                         }, this.data.items[i])
        //                     ).appendTo(p);
        //                     show = true;
        //                 }
        //             }
    
        //             if (this.options.callback) {
        //                 this.options.callback.call(this.element, show);
        //             }
        //         }
        //     });
    
        //     $.fn[pluginName] = function (options) {
        //         return this.each(function () {
        //             var name = "plugin_" + pluginName, plugin = $.data(this, name);
        //             if (!plugin) {
        //                 $.data(this, name, new ForumBox(this, options));
        //             }
        //         });
        //     };
    
        // })(jQuery);
    
    ellipsisSetup() {}
        
    
        
    
    }

    (function ($) {
    
        // original author: http://stackoverflow.com/questions/536814/insert-ellipsis-into-html-tag-if-content-too-wide/9071361#9071361

        var pluginName = "ellipsis";

        // this is a binary search that operates via a function
        // func should return < 0 if it should search smaller values
        // func should return > 0 if it should search larger values
        // func should return = 0 if the exact value is found
        // Note: this function handles multiple matches and will return the last match
        // this returns -1 if no match is found
        function binarySearch(length, func) {
            var low = 0,
                high = length - 1,
                best = -1,
                mid,
                result;

            while (low <= high) {
                mid = ~ ~((low + high) / 2);
                result = func(mid);
                if (result < 0) {
                    high = mid - 1;
                } else if (result > 0) {
                    low = mid + 1;
                } else {
                    best = mid;
                    low = mid + 1;
                }
            }

            return best;
        }

        // create the ellipsis function
        // when addTooltip = true, add a title attribute with the original text
        $.fn[pluginName] = function (addTooltip, saveContent) {

            return this.each(function () {
                var el = $(this), content, multi, tempElement, rows, lineheight, tooLongFunc, tooltipText, originalContent, len;

                if (el.is(":visible")) {
                    multi = el.hasClass('multiline');
                    // Check if custom attribute for plugin is specified and parse it as int to get number of rows
                    rows = ~~el.attr("data-" + pluginName);
                    if (rows) {
                        lineheight = ~~el.css("lineHeight").trim(["p", "x"]);
                        if (lineheight) {
                            // if data-maxrows and style line-height are integer values, force multiline
                            multi = true;
                            // ensure element height is less than (rows * lineheight)
                            if (el.height() > (rows * lineheight)) {
                                el.height(rows * lineheight)
                                // ensure overflow:hidden for comparison
                                .css("overflow", "hidden");
                            }
                        }
                    }

                    if (el.css("overflow") === "hidden") {
                        content = el.html();

                        // Clone and style the new element for comparison
                        tempElement = $(this.cloneNode(true))
                            .hide()
                            .css({
                                position: "absolute",
                                overflow: "visible",
                                maxHeight: "none",
                                maxWidth: "none",
                                whiteSpace: multi ? "normal" : "nowrap",
                                height: multi ? 'auto' : el.height(),
                                width: multi ? el.width() : 'auto'
                            });

                        el.after(tempElement);

                        function tooTallFunc() {
                            return tempElement.height() > el.height();
                        };

                        function tooWideFunc() {
                            return tempElement.width() > el.width();
                        };

                        tooLongFunc = multi ? tooTallFunc : tooWideFunc;

                        // if the element is too long...
                        if (tooLongFunc()) {

                            originalContent = content;

                            // if content was requested to be saved...
                            if (saveContent) {
                                $.data(this, "plugin_" + pluginName, originalContent);
                            }

                            // if a tooltip was requested...
                            if (addTooltip || el.hasClass(pluginName + "-tooltip")) {
                                // trim leading/trailing whitespace
                                // and consolidate internal whitespace to a single space
                                tooltipText = $.trim(el.text()).replace(/\s\s+/g, ' ');
                            }

                            function createContentFunc(i) {
                                content = originalContent.substr(0, i);
                                tempElement.html(content + "…");
                            };

                            function searchFunc(i) {
                                createContentFunc(i);
                                if (tooLongFunc()) {
                                    return -1;
                                }
                                return 0;
                            };

                            len = binarySearch(content.length - 1, searchFunc);

                            createContentFunc(len);

                            el.html(tempElement.html());

                            // add the tooltip if appropriate
                            if (tooltipText) {
                                el.attr('title', tooltipText);
                            }
                        }

                        tempElement.remove();
                    }
                }
                else {
                    // if this isn't visible, then hook up the show event
                    el.one('show', function () {
                        $(this)[pluginName](addTooltip);
                    });
                }
            });
        };

    })(jQuery);

    (function ($, window, document, undefined) {
        "use strict";

        // Create the defaults once
        var pluginName = "suggestions",
            defaults = {
                chars: 3,
                // TODO Change/remove
                position: { top: 0, left: 0 },
                serviceUrl: null,
                timeout: 500,
                type: -1
            },
            _PARENT_TMPL = "<div class='suggestions'><div class='suggestions-inner'></div></div>",
            _ITEM_TMPL = "<div class='suggestion'>{0}</div>";

        // The actual plugin constructor
        function Suggestions(element, options) {
            this.element = element;
            this.settings = $.extend({}, defaults, options);
            this.init();
        }

        $.extend(Suggestions.prototype, {
            init: function () {
                if (this.settings.serviceUrl === null) {
                    throw new TypeError("Service URL is not specified");
                }

                this.container = this.ensureContainer();
                this.handle = 0;
                this.hideHandle = 0;
                this.length = 0;
                this.position = -1;
                this.text = null;
                this.serviceUrl = this.settings.serviceUrl;
                this.visible = false;
                this.preventBlur = false;

                this.binds();
            },
            binds: function () {
                var self = this;

                // bind suggestion click
                this.container.on("mousedown", ".suggestion", function () {
                    self.preventBlur = true;
                })
                .on("click", ".suggestion", function (e) {
                    clearTimeout(self.hideHandle);
                    var me = $(this);
                    self.element.value = me.attr("title") || me.text();
                    if (vccsupport.is(vccsupport.jstypes.func, self.settings.click)) {
                        self.settings.click();
                    }
                    self.preventBlur = false;
                    self.hide();
                });

                // bind keyup to search
                $(this.element).on("keyup", function (e) {
                    switch (e.which) {
                        case 13:
                            $(self.element).blur();
                        case 37:
                        case 38:
                        case 39:
                        case 40:
                            // do nothing
                            return;
                        default:
                            break;
                    }

                    // trigger event
                    self.trigger(this.value);
                })
                // bind keydown to navigate dropdown list
                .on("keydown", function (e) {
                    switch (e.which) {
                        case 38: // up
                            self.move(-1);
                            break;
                        case 40: // down
                            self.move(1);
                            break;
                        default:
                            return;
                    }
                    e.preventDefault();
                })
                // bind blur to reset text field
                .on("blur", function () {
                    self.position = -1;
                    if (self.preventBlur === false) {
                        self.hideHandle = setTimeout(function () {
                            self.hide();
                        }, 50);
                    }
                    self.preventBlur = false;
                })
                // bind focus to show dropdown list if it exists
                .on("focus", function () {
                    self.position = -1;
                    if (self.visible) {
                        self.show();
                    }
                });
            },
            show: function () {
                this.container.css("visibility", "visible");
            },
            hide: function () {
                this.container.css("visibility", "hidden");
            },
            move: function (dir) {
                if (this.length === 0) return;

                var pos = this.position + dir,
                    items = this.container.find(".suggestion").removeClass("selected");

                if (pos < -1) {
                    this.position = this.length - 1;
                }
                else if (pos >= this.length) {
                    this.position = -1;
                }
                else {
                    this.position = pos;
                }

                if (this.position === -1) {
                    // Set original text in textbox
                    this.element.value = this.text;
                }
                else {
                    this.element.value = items.eq(this.position).text();
                    items.eq(this.position).addClass("selected");
                }
            },
            trigger: function (text) {
                var self = this;
                // Stop current timeout
                clearTimeout(this.handle);

                if (!text || text.length === 0) {
                    self.container.find(".suggestions-inner").html("");
                    self.hide();
                    self.visible = false;
                    self.text = null;
                }
                else {
                    // Set new timeout
                    this.handle = setTimeout(function () {
                        if (self.ready(text)) {
                            self.search(text);
                        }
                    }, this.settings.timeout);
                }
            },
            ready: function (text) {
                if (!text) {
                    return false;
                }

                var len = ~~this.settings.chars;
                if (len > 0) {
                    if (text.length < len) {
                        return false;
                    }
                }

                if (this.text) {
                    if (text.toLowerCase() === this.text.toLowerCase()) {
                        return false;
                    }
                }

                return true;
            },
            search: function (text) {
                // Check for selected model
                var uri = new vccsupport.Uri(this.serviceUrl), model = vccsupport.getCurrentModel();

                // Store search text
                this.text = text;

                // Add query
                uri.parameters["q"] = encodeURIComponent(this.text);

                if (this.settings.type !== -1) {
                    // Add type
                    uri.parameters["t"] = this.settings.type.toString();
                }

                // Get request URL
                var url = uri.toString(true);
                
                var self = this;
                $.ajax({
                    url: url,
                    modelSegment: "GET",
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    success: function (data) {
                        self.onResponse(data);
                    }
                });
            },
            onResponse: function (response) {
                if (response) {
                    if (response.results) {
                        this.length = response.results.length;
                        this.render(response);
                    }
                }
                this.handle = 0;
            },
            render: function (response) {
                var i,
                    self = this,
                    p = this.container.find(".suggestions-inner").html("");
                this.position = -1;
                if (response.results && response.results.length) {
                    for (i = 0; i < response.results.length; i++) {
                        var item = _ITEM_TMPL.format(this.markQueryText(response.results[i].title));
                        // Mark query text in result and add item
                        p.append(item);
                    }
                    this.visible = true;
                    this.show();
                    this.container.find(".suggestion").ellipsis(true);
                }
                else {
                    this.hide();
                    this.visible = false;
                }
            },
            ensureContainer: function () {
                var p = $(".suggestions", this.element.parentElement);

                if (p.length === 0) {
                    p = $(_PARENT_TMPL).appendTo(this.element.parentElement);
                }

                return p;
            },
            markQueryText: function (text) {
                var q = this.text.toLowerCase(),
                    t = text.toLowerCase(),
                    marked = "",
                    start, end;

                start = t.indexOf(q);
                if (start !== -1) {
                    end = start + q.length;
                    marked += text.substring(0, start);
                    marked += "<span>" + text.substring(start, end) + "</span>";
                    marked += text.substring(end);
                }

                if (marked.length === 0) {
                    marked = text;
                }

                return marked;
            }
        });

        $.fn[pluginName] = function (options) {
            return this.each(function () {
                if (!$.data(this, "plugin_" + pluginName)) {
                    $.data(this, "plugin_" + pluginName, new Suggestions(this, options));
                }
            });
        };

    })(jQuery, window, document);